// Constants for different requests for current reducer
export default {
  profileFields: 'PROFILE_FIELDS',
  profileFieldResults: 'PROFILE_FIELD_RESULTS',
  updateProfileFields: 'UPDATE_PROFILE_FIELDS',
  updateProfileFieldResults: 'UPDATE_PROFILE_FIELD_RESULTS',
  updateProfileBuilderFields: 'UPDATE_PROFILE_BUILDER_FIELDS',
  addProfileField: 'ADD_PROFILE_FIELD',
};
